// extracted by mini-css-extract-plugin
export default {"DanhGiaDashBoard":"DanhGiaDashBoard_DanhGiaDashBoard__I0U79"};